import axios from 'axios';
import { apiUrl, authURL } from '../config/urls';
import { User } from '../@types/users/user';

export const getToken = async () => {
  axios.interceptors.request.use(
    config => {
      const accessToken = localStorage.getItem('access_token');
      if (accessToken) {
        config.headers['access-token'] = `${accessToken}`;
      }
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );
};

export const getAccessToken = async (username: string, password: string) => {
  const data = new URLSearchParams();
  data.append('client_id', 'gold');
  data.append('username', username);
  data.append('password', password);
  data.append('grant_type', 'password');

  const config = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  };

  const response = await axios.post(`${authURL}/token`, data, config);

  getToken();
  return response.data.access_token;
};


export const validateUser = async (access_token: string) => {
  try {
    const auth = await axios.get<User>(`${apiUrl}/user/auth/validate`, {
      headers: {
        'access-token': access_token,
        'Content-Type': 'application/json'
      }
    });
    return auth.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || 'User validation failed');
  }
};

export const validateUserService = async (access_token: string) => {
  try {
    const auth = await axios.get<boolean>(`${apiUrl}/user/auth/validate/service`, {
      headers: {
        'access-token': access_token,
        'Content-Type': 'application/json'
      },
    });
    return auth.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || 'User service validation failed');
  }
};